import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'offers/customerOffers',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const CustomerOffers = require('./containers/CustomerOffers').default;
        cb(null, CustomerOffers)
      }, 'CustomerOffers')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/CustomerOffers/index.js